import React, { useContext } from 'react'
import { array } from 'prop-types'

import Grid from '../../Grid'
import Card from '../../Card'
import Surround from '../../Surround'
import Icon from '../../Icon'
import Tag from '../../Tag'
import CardButton from '../../Card/component/CardButton'
import { ThemeContext } from '@/component/Context/ThemeContext'
import brandToColor from '@/lib/brand-to-color'

const CardGrid6 = ({ articles }) => {
  const { theme } = useContext(ThemeContext)
  if (!articles.length) return null
  const themecolor = brandToColor(theme)
  const remainingArticles = articles.slice(1)
  const firstArticleIsLive = articles[0].isLive
  const imageRatio = 126 / 167

  return (
    <Grid flex gutter="default">
      <Grid.Item width={{ m: 1 / 2, d: 1 / 4 }} trailingGap="default">
        <Surround
          bordered={!firstArticleIsLive && 'default'}
          padded={!firstArticleIsLive && 'default'}
        >
          <Card
            typeConfig={{
              title: { size: ['heading7', 'heading6'], themed: true },
              description: { size: ['body2', 'body4'] }
            }}
            inverse={firstArticleIsLive}
            inset={firstArticleIsLive}
            headerComponents={
              firstArticleIsLive
                ? () => (
                    <>
                      <Icon a11yText="Live" type="live" />
                      <Tag
                        style={{
                          border: `1px solid ${themecolor}`,
                          color: themecolor
                        }}
                        uppercase
                        background="black"
                      >
                        Live on BMG Connect
                      </Tag>
                    </>
                  )
                : undefined
            }
            footerComponents={() => (
              <CardButton>{articles[0].ctaText}</CardButton>
            )}
            themedEyebrow={firstArticleIsLive}
            {...{
              ...articles[0],
              sizes: [
                '(min-width: 1420px) 322px',
                '(min-width: 960px) calc(25vw - 32px - 80px)',
                'calc((100vw - 80px) * 0.5)'
              ],
              width: 322
            }}
            imageRatio={imageRatio}
          />
        </Surround>
      </Grid.Item>
      {remainingArticles.map((article, i) => (
        <Grid.Item
          hidden={i > 2 ? 'mobile' : null}
          key={i}
          width={{ m: 1 / 2, d: 1 / 4 }}
          trailingGap="default"
        >
          <Surround bordered="default" padded="default">
            <Card
              typeConfig={{
                title: { size: ['heading7', 'heading6'], themed: true },
                description: { size: ['body2', 'body4'] }
              }}
              footerComponents={() => (
                <CardButton>{articles[0].ctaText}</CardButton>
              )}
              {...{
                ...article,
                sizes: [
                  '(min-width: 1420px) 322px',
                  '(min-width: 960px) calc(25vw - 32px - 80px)',
                  'calc((100vw - 80px) * 0.5)'
                ],
                width: 322
              }}
              imageRatio={imageRatio}
            />
          </Surround>
        </Grid.Item>
      ))}
    </Grid>
  )
}

CardGrid6.propTypes = {
  articles: array
}

export default CardGrid6
